import { SaveContainerRepository } from "@/repository/save_container_repository";
import { SaveContainerService } from "@/service/import/save_container_service";
import { defineStore } from "pinia";

export const useSaveContainer = defineStore("saveContainerStore", {
  state: (): {
    assetApiError: { failed: boolean; message: string; params: any };
    containers: string[];
    savedContainers: string[];
    alreadySavedContainer: string[];
    loader: boolean;
    containerSavedSuccessful: boolean;
  } => ({
    containers: [],
    savedContainers: [],
    alreadySavedContainer: [],
    assetApiError: { failed: false, message: "", params: {} },
    loader: false,
    containerSavedSuccessful: false
  }),
  persist: false,
  getters: {},
  actions: {
    // Add search ids to the store searchIds array
    async saveContainer(saveContainerPayload): Promise<void> {
      //  Add a timer to simulate the API call
      this.loader = true;
      try {
        const repository = new SaveContainerRepository(new SaveContainerService());
        const response = await repository.saveContainers(saveContainerPayload);
        this.savedContainers = response.saved;
        this.alreadySavedContainer = response.unsaved;
        this.containerSavedSuccessful = true;
        this.loader = false;
      } catch (e) {
        this.loader = false;
        this.assetApiError = { failed: true, message: e.message, params: {} };
        this.containerSavedSuccessful = false;
      }
    },

    // Clear all states
    clearAllStates(): void {
      this.assetApiError = { failed: false, message: "", params: {} };
      this.loader = false;
      this.containerSavedSuccessful = false;
      this.savedContainers = [];
      this.alreadySavedContainer = [];
    }
  }
});
